export { MediaPage as default } from '@/components/pages/Contact/Media'
